<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
const customerId = localStorage.getItem("customerId")
export default {
    extends: baseList,
    components: {

    },
    data() {
        return {
            table: {
                mname: "list",
                key: "id",
                url: {
                    list: "/admin/system/customer/list",
                },
                output: false,
                order: "createTime",
            },
            query: {
            },
            actions: [
            ],
            menus: [

            ],
            filters: [
                // {
                //   label: "盘点人",
                //   KeyEnter: this.search,
                //   name: "createBy",
                //   value: "",
                //   type: "input",
                // },
                // // {
                // //   label: "负责人",
                // //   KeyEnter: this.search,
                // //   name: "maintainerId",
                // //   value: "",
                // //   type: "select",
                // //   dropList: [],
                // // },
                // {
                //   label: "盘点时间",
                //   KeyEnter: this.search,
                //   name: "",
                //   value: "",
                //   type: "contractdatetimerange",
                // },
            ],
            tableCols: [
                {
                    title: "序号",
                    type: "index",
                    width: 80,
                    align: "center",
                },
                {
                    title: "客户名称",
                    key: "customerName",
                    minWidth: 120,
                    align: "left",
                },
                {
                    title: "操作",
                    align: "center",
                    width: 210,
                    key: "handle",
                    fixed: "right",
                    handle: [
                        (vm, h, currentRow, param) => {
                            // let directives = []
                            return (
                                <Button
                                    size="small"
                                    onClick={() => this.toinfo(currentRow)}
                                    type="default"
                                    style={{
                                        border: "none",
                                        color: "#4991ff", margin: "0",
                                    }}
                                >
                                    详情
                                </Button>
                            );
                        },
                    ],
                    auth: {
                        // edit: "system/knowledgeBaseTag/edit",
                        // del: "system/inspection/delete",
                    },
                },
                // {
                //     title: "总费用",
                //     key: "serviceMoney",
                //     minWidth: 200,
                //     align: "left",
                //     render: (h, params) => {
                //         const row = params.row;
                //         const text = row.serviceMoney
                //         return (
                //             <span
                //             >
                //                 {text}
                //             </span>
                //         );
                //     },
                // },
                // {
                //   title: "盘点人",
                //   key: "createBy",
                //   minWidth: 100,
                //   align: "left",
                // },
                // {
                //   title: "盘点时间",
                //   key: "createTime",
                //   minWidth: 120,
                //   align: "left",
                // },
            ],
        };
    },
    created() {
    },
    methods: {
        //查询维修员
        loaduserData() {
            // 通过pk查询字典数据
            let q = {};
            $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
                if (res && res.rows) {
                    let ll = res.rows;
                    let dropList = [];
                    for (let index = 0; index < ll.length; index++) {
                        const element = ll[index];
                        let xx = {};
                        xx.value = element.id;
                        xx.name = element.nickName;
                        xx.children = element.children || [];
                        dropList.push(xx);
                    }
                    for (let index = 0; index < this.filters.length; index++) {
                        const element = this.filters[index];
                        if (element && element.name == "maintainerId") {
                            // this.items[index]['dropList'] = dropList
                            this.filters[index]["dropList"] = (
                                this.filters[index]["dropList"] || []
                            ).concat(dropList);
                        }
                    }
                }
            });
        },
        toAdd() {
            $utils.url.push({ name: "inspection_add", query: { action: "add" } });
        },
        toinfo(row) {
            window.localStorage.setItem("customerIdClick", row.id)
            window.localStorage.setItem("customerNameClick", row.customerName)
            $utils.url.push({
                name: "listOfCharges_list"
            });
        },
    },
};
</script>
<style scoped></style>
